import React, { useState, useEffect, useRef } from "react";
import "./ChatBot.css";
import maxwell from "./maxwell.png";
import Dropdown from "react-dropdown";
import ChatApi from "../../api/ChatApi";
import Cookies from "js-cookie";

export default function ChatBot() {
    const token = Cookies.get("Session");

    const [chatView, setChatView] = useState("closed");

    const [userInput, setUserInput] = useState("");

    const [messages, setMessages] = useState([
        {
            id: 0,
            text: "Hey! Do you have a general question or a specific question about an equipments history?",
        },
    ]);

    const [isTyping, setIsTyping] = useState(false);

    const onUserSendMessage = (text) => {
        if (text == "") {
            return;
        }

        setUserInput("");
        setMessages((hist) => {
            return [
                {
                    id: 1,
                    text: text,
                },
                ...hist,
            ];
        });

        ChatApi.getBedrockChat2(token, text, messages)
            .then((response) => {
                if (response.status == 200) {
                    const text = response.data.content.answer;
                    setMessages((hist) => {
                        return [
                            {
                                id: 0,
                                text: text,
                            },
                            ...hist,
                        ];
                    });
                } else {
                    setMessages((hist) => {
                        return [
                            {
                                id: 0,
                                text: `${response.status}: Error Processing Request. Try again Later`,
                            },
                            ...hist,
                        ];
                    });
                }
            })
            .catch((err) => {
                console.log(err);
                setMessages((hist) => {
                    return [
                        {
                            id: 0,
                            text: `Error Processing Request. Try again Later`,
                        },
                        ...hist,
                    ];
                });
            });
    };

    return (
        <div id="chatbot" className={chatView}>
            <div className="open-button">
                <button onClick={() => setChatView("open")}>
                    <img src={maxwell} className="maxwell" alt="maxwell icon" />
                </button>
            </div>
            <div className="container">
                <div className="head">
                    <img src={maxwell} className="maxwell" alt="maxwell icon" />
                    <div>
                        {chatView == "open" && (
                            <button onClick={() => setChatView("max")} title="Maximize">
                                ⛶
                            </button>
                        )}
                        {chatView == "max" && (
                            <button onClick={() => setChatView("open")} title="Minimize">
                                -
                            </button>
                        )}
                        <button onClick={() => setChatView("closed")} title="Close">
                            X
                        </button>
                    </div>
                </div>
                <div className="chat-area">
                    <div className="chat-feed">
                        {messages.map((msg) => {
                            return <p className={"message " + (msg.id == 0 ? "bot" : "user")}>{msg.text}</p>;
                        })}
                    </div>
                </div>
                <div className="chat-input">
                    <textarea
                        type="text"
                        placeholder=""
                        class="search"
                        value={userInput}
                        onChange={(e) => setUserInput(e.target.value)}
                        onKeyDown={(e) => {
                            if (e.key == "Enter") {
                                e.preventDefault();
                                onUserSendMessage(userInput);
                            }
                        }}
                    />
                    <button onClick={() => onUserSendMessage(userInput)}>{">"}</button>
                </div>
            </div>
        </div>
    );
}
